import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { initSentry, SentryErrorBoundary } from "@/lib/sentryInit";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import DownloadCenter from "@/pages/DownloadCenter";
import SubmissionLog from "@/pages/SubmissionLog";
import QaQueue from "@/pages/QaQueue";
import AgencyBranding from "@/pages/AgencyBranding";
import DraftsPending from "@/pages/DraftsPending";
import PaOutcomesInbox from "@/pages/PaOutcomesInbox";
import IntegrationHealth from "@/pages/IntegrationHealth";
import ComponentPlayground from "@/pages/ComponentPlayground";
import NotFound from "@/pages/NotFound";
import { WizardProvider } from "@/context/WizardContext";
import TourOverlay from "@/components/wizard/TourOverlay";
import OfflineBanner from "@/components/OfflineBanner";

// Initialize Sentry once at module load — must happen before the app
// renders so the SDK can instrument fetch/XHR/router from the start.
initSentry();

function App() {
  return (
    <SentryErrorBoundary
      fallback={
        <div style={{ padding: "40px", textAlign: "center", fontFamily: "Inter, sans-serif" }}>
          <h1 style={{ color: "#0B1E3A", fontSize: "28px", marginBottom: "12px" }}>
            Something went wrong
          </h1>
          <p style={{ color: "#3A5275" }}>
            Our team has been notified. Please refresh the page or contact support.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "20px", padding: "10px 20px",
              background: "#0A3D79", color: "white",
              border: "none", borderRadius: "6px", cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      }
    >
      <div className="App bg-paper" data-testid="app-root">
      <BrowserRouter>
        <WizardProvider>
          <OfflineBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/wizard" element={<Wizard />} />
            <Route path="/wizard/:step" element={<Wizard />} />
            <Route path="/download/:jobId" element={<DownloadCenter />} />
            <Route path="/submissions" element={<SubmissionLog />} />
            <Route path="/qa" element={<QaQueue />} />
            <Route path="/drafts/pending" element={<DraftsPending />} />
            <Route path="/drafts/pa-outcomes" element={<PaOutcomesInbox />} />
            <Route path="/admin/integration-health" element={<IntegrationHealth />} />
            <Route path="/settings/brand" element={<AgencyBranding />} />
            {/* Legacy redirects — earlier paths that coordinators may have
                bookmarked. Keep these even after the canonical route changes. */}
            <Route path="/agency-branding" element={<Navigate to="/settings/brand" replace />} />
            <Route path="/qa-queue" element={<Navigate to="/qa" replace />} />
            <Route path="/dev/components" element={<ComponentPlayground />} />
            {/* 404 catch-all — must be last. */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <TourOverlay />
        </WizardProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      </div>
    </SentryErrorBoundary>
  );
}

export default App;
